// extracted by mini-css-extract-plugin
export default {"colorexploratoryrunfail":"#ffcece","colordirectrunfail":"#e90029","chartContainerStyle":"FailureTypeChart_chartContainerStyle__4I0d9"};